import { render, staticRenderFns } from "./NeedAddToNewSearch.vue?vue&type=template&id=27859b56&"
import script from "./NeedAddToNewSearch.vue?vue&type=script&lang=js&"
export * from "./NeedAddToNewSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports